import timeZonesEnam from '@/constant/timeZonesEnam';
import { getLinkToMeeting } from '@/helpers/new/getLinkToMeeting';
import { getDefaultTimezone } from '@/helpers/new/time/getDefaultTimezone';
import { timezoneOffsets } from '@/helpers/new/time/timezoneOffsets';
import moment from 'moment';

export const getCurrentReport = (reports, baseTimezone = timeZonesEnam.GMT_MINUS_3) => {
    const now = moment();

    const userTimezone = getDefaultTimezone();

    const userOffset = timezoneOffsets[userTimezone] || 3;
    const baseOffset = timezoneOffsets[baseTimezone] || 3;
    const offsetDiff = userOffset - baseOffset;

    let currentReport = null;
    
    reports.forEach(report => {
        const startTimeBase = moment(`${report.date_conference} ${report.start_time}`, 'YYYY-MM-DD HH:mm');
        const endTimeBase = moment(`${report.date_conference} ${report.end_time}`, 'YYYY-MM-DD HH:mm');
        
        const startTimeUser = startTimeBase.clone().add(offsetDiff, 'hours');
        const endTimeUser = endTimeBase.clone().add(offsetDiff, 'hours');
        
        if (now.isBetween(startTimeUser, endTimeUser) && !!getLinkToMeeting({report})) {
            currentReport = report;
        }
    });
    
    return currentReport;
}